
<div class="validarCuentas__modal content">
    <div class="validarCuentas__modal__close">
        <ion-button
        class="close-icon"
        fill="clear"
        shape="round"
        slot="icon-only"
        (click)="close()"
        (keydown.enter)="close()"
    >
        <ion-icon name="close" color="primary"> </ion-icon>
    </ion-button>
    </div>
    <div class="validarCuentas__modal__header">
        <div class="imagen">
          <informacion-svg></informacion-svg>
        </div>
    </div>
    <div class="validarCuentas__modal__body">
        <ng-container *ngIf="origenValidacion === constanteValidarCuentasBancarias">
            <h1 class="titulo">{{titulo}}</h1>
            <form [formGroup]="form">
                <div  class="validarCuentas__modal__body__info-checkLegal">
                    <div class="validarCuentas__modal__body__info-checkLegal-check">
                        <ion-checkbox
                        slot="start"
                        formControlName="checkValidar"
                    ></ion-checkbox>
                    </div>
                    <ion-label class="label-checkLegal"
                        >Declaro que quiero utilizar esta cuenta aunque no se haya validado su existencia, ya sea por ingresar mal un dato o que la cuenta es reciente (menor a 6 meses)
                    </ion-label>
                </div>
            </form>
        </ng-container>
        <ng-container *ngIf="origenValidacion === constanteValidarCuentasDigitales">
            <h1 class="titulo">{{titulo}}</h1>
            <p class="parrafo">{{parrafo}}</p>
        </ng-container>

    </div>
    <ng-container *ngIf="origenValidacion === constanteValidarCuentasDigitales">
        <div class="validarCuentas__modal__buttons">
            <ion-button
                shape="round"
                (click)="botonAgregarOtraCuenta(false)"
                (keydown.enter)="botonAgregarOtraCuenta(false)"
                expand="full"
                class="next">
                <ion-label >{{nombreBoton}}</ion-label>
            </ion-button>
        </div>
    </ng-container>
    <ng-container *ngIf="origenValidacion == constanteValidarCuentasBancarias">
        <div class="validarCuentas__modal__buttons">
            <ion-button
                (click)="botonIngresar()"
                (keydown.enter)="botonIngresar()"
                shape="round"
                color="contratsprimary"
                class="close"
                expand="full">
                Ingresar nueva cuenta
            </ion-button>
            <ion-button
                shape="round"
                (click)="botonAgregarOtraCuenta(true)"
                (keydown.enter)="botonAgregarOtraCuenta(true)"
                [disabled]="isInvalidForm"
                expand="full"
                class="next">
                <ion-label >{{nombreBoton}}</ion-label>
            </ion-button>
        </div>
    </ng-container>
</div>